export class ChartDataFft {
    label = "";
    data: number[] = [];
    fill = false;
    lineTension = 0.1;
    borderWidth = 0;
    borderColor = "";
    backgroundColor = "white";
  }
  